// Simple utility to log environment variables for debugging
export const logEnvVariables = () => {
  console.log('Environment Variables:');
  console.log('NODE_SERVER_URL:', process.env.REACT_APP_NODE_SERVER_URL || 'undefined');
  console.log('PYTHON_BACKEND_URL:', process.env.REACT_APP_PYTHON_BACKEND_URL || 'undefined');
  console.log('WEBSOCKET_URL:', process.env.REACT_APP_WEBSOCKET_URL || 'undefined');
  console.log('GOOGLE_MAPS_API_KEY:', process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? 'defined' : 'undefined');
};

// Check if variables are properly defined
export const hasRequiredEnvVars = () => {
  return Boolean(
    process.env.REACT_APP_NODE_SERVER_URL &&
    process.env.REACT_APP_PYTHON_BACKEND_URL &&
    process.env.REACT_APP_WEBSOCKET_URL
  );
}; 